export class AppFirebaseConfig {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}

export class AppGoogleMapsConfig {
  apiKey: string
  snapUrl: string

  getSnapToRoadsUrl (locations: string[]) {
    return `${this.snapUrl}?path=${locations.join('|')}&key=${this.apiKey}`
  }
}

export class AppMapboxConfig {
  accessToken: string
  directionsUrl : string

  getDirectionsUrl (origin: string, destination: string) {
    return `${this.directionsUrl}${origin};${destination}?geometries=geojson&overview=full&access_token=${this.accessToken}`
  }
}

export class AppTrackingConfig {
  snapToRoadsPageRequestSize: number
}

export class AWSS3Config {
  bucketName: string
  awsAccessKeyId: string
  awsSecretAccessKey: string
  awsS3Region: string
  errorsTranslateFile: string
}

class Headers {
  jwtRefreshToken: string
}

export const HeadersKeys = {
  JWT_REFRESH_TOKEN: 'jwt-refresh-token'
}

export class AppConfig {
  enviroment: string
  isProduction: boolean
  activeLogs: boolean
  apiPlatformUrl: string
  apiFillsUrl: string
  apiUsersUrl: string
  apiReportsUrl: string
  basePath: string
  appDomain: string
  /**
   * @deprecated
   */
  accessTokenCookieName: string
  jwtAccessTokenCookieName: string
  refreshTokenCookieName: string
  projectIdCookieName: string
  domainIdCookieName: string
  domainUIDCookieName: string
  firebase = new AppFirebaseConfig()
  googleMaps = new AppGoogleMapsConfig()
  mapbox = new AppMapboxConfig()
  tracking = new AppTrackingConfig()
  awsS3 = new AWSS3Config()
  headers: Headers = new Headers()
}

export const NodeEnv = {
  DEV: 'development',
  TEST: 'test',
  STAGE: 'stage',
  PREPROD: 'preprod',
  PRODUCTION: 'production'
}

export const PRODUCTION_ENVIROMENTS = [
  NodeEnv.STAGE,
  NodeEnv.PREPROD,
  NodeEnv.PRODUCTION
]

export const COOKIES = {
  LAST_LOGIN: 'last-login'
}
